import type { ReactNode, ElementType } from "react";
import styled from "styled-components";

type PageTitleProps = {
  children: ReactNode;
  icon?: ReactNode;
  center?: boolean;
  gap?: number | string;
  as?: ElementType;
  className?: string;
};

export default function PageTitle({
  children,
  icon,
  center = true,
  gap = 8,
  as = "h1",
  className,
}: PageTitleProps) {
  return (
    <TitleWrapper as={as} $center={center} $gap={gap} className={className}>
      {icon}
      {children}
    </TitleWrapper>
  );
}

const TitleWrapper = styled.h1<{ $center: boolean; $gap: number | string }>`
  margin: 0 auto;
  font-size: clamp(1.4rem, 2.2vw, 2rem);
  font-weight: 500;
  color: var(--text);
  display: flex;
  align-items: center;
  justify-content: ${({ $center }) => ($center ? "center" : "flex-start")};
  gap: ${({ $gap }) => (typeof $gap === "number" ? `${$gap}px` : $gap)};
  text-align: ${({ $center }) => ($center ? "center" : "start")};
  width: 100%;
`;
